import {
  createStyles,
  Dialog,
  IconButton,
  makeStyles,
  Theme,
} from '@material-ui/core'
import React from 'react'
import {useAppDispatch, useAppSelector} from 'hooks'
import {
  closeReportImageDialog,
  selectReportImageDialogOpen,
} from 'features/modal/modalSlice'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      '& > .MuiDialog-container > .MuiPaper-root': {
        [theme.breakpoints.up('xs')]: {
          minWidth: 300,
        },
        [theme.breakpoints.up('sm')]: {
          minWidth: 500,
        },
        [theme.breakpoints.up('md')]: {
          minWidth: 650,
        },
        [theme.breakpoints.up('lg')]: {
          minWidth: 1550,
        },
      },
    },
    closeButtonWrap: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginRight: '15px',
      marginTop: '10px',
    },
    closeButton: {
      backgroundColor: '#f4f4f4',
      width: 20,
      height: 20,
    },
    contentContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      overflowY: 'auto',
      height: 700,
      background: 'white',
      padding: 20,
      justifyContent: 'center',
      alignItems: 'center',
    },
    closeIcon: {
      width: 20,
      height: 20,
      color: '#c5c5c5',
    },
  }),
)

const ReportImageDialog = () => {
  const classes = useStyles()
  const {reportImageDialogOpen: open, reportImageDialogId: packageId} =
    useAppSelector(selectReportImageDialogOpen)
  const dispatch = useAppDispatch()
  const handleClose = () => {
    dispatch(closeReportImageDialog())
  }

  const reportFiles: Record<string, string> = {
    '1': '/EEGIndividual.html',
    '2': '/EEGIndividual3D.html',
    '3': '/BrainFunctionMappingBasic.html',
    '4': '/BrainFunctionMappingAdv.html',
    '5': '/EEGNorm.html',
    '6': '/EEGNorm3D.html',
    '7': '/MciFiveStages.html',
    '8': '/HRVIndividual.html',
    '9': '/HRVSummaryBasic.html',
    '10': '/HRVSummaryAdv.html',
    '27': '/FiveIndicators.html',
    '28': '/BrainFunctionConnectivity.html',
    '29': '/MciEightStages.html',
  }

  return (
    <Dialog open={open} onClose={handleClose} className={classes.container}>
      <div className={classes.closeButtonWrap}>
        <IconButton
          color='secondary'
          aria-label='favorite'
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon className={classes.closeIcon} />
        </IconButton>
      </div>
      <div className={classes.contentContainer}>
        <iframe
          src={reportFiles[packageId]}
          title='html_template'
          width='100%'
          height='100%'
        />
      </div>
    </Dialog>
  )
}

export default ReportImageDialog
